import { createResourceQuery } from './factory'

type Props = {
   organizationId?: string
   enabled?: boolean
}

export const useAdminlog = createResourceQuery<'adminlog', Props>({
   queryKey: 'adminlog',
   view: 'adminlog',
   order: [{ column: 'created_at', ascending: false }],
   filters: (query, props) => {
      if (props.organizationId) query.eq('organization_id', props.organizationId || '')
   },
})
